import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DateDisplay } from './leave-pop-up.interface';
import { DatePipe, DecimalPipe } from '@angular/common';
import { IMyOptions, IMyDateModel } from 'mydatepicker';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-leave-pop-up',
  templateUrl: './leave-pop-up.component.html',
  styleUrls: ['./leave-pop-up.component.css']
})
export class LeavePopUpComponent implements OnInit {
  public dateDisplay: Array<any> = [];
  public currentDate: any;
  public currentDateDay: any;
  public currentWeak: any;
  public getPreviousWeekDate: any;
  public firstDay: any;
  public firstDayDate: any;
  public lastDay: any;
  public lastDayDate: any;
  public yearFirst: any;
  public yearLast: any;
  public currentYear: any;
  public weekNumer: any;
  public taskListFlag: boolean;

  public myDatePickerFromOptions: IMyOptions;
  public myDatePickerToOptions: IMyOptions;
  public fromDate: any;
  public toDate: any;
  public fromDateError: any = '';
  public toDateError: any = '';
  public leaveStatus = false;
  public leaveForm: FormGroup;
  public submitted = false;

  constructor(
    public dialogRef: MatDialogRef<LeavePopUpComponent>,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    dialogRef.disableClose = true;
    const date: Date = new Date();
    date.setDate(date.getDate() - 1);
    this.myDatePickerFromOptions = {
      dateFormat: 'dd-mm-yyyy',
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      inline: false,
      disableUntil: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      }
    };

    this.myDatePickerToOptions = {
      dateFormat: 'dd-mm-yyyy',
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      disableUntil: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      }
    };
  }

  ngOnInit() {
    this.leaveForm = this.formBuilder.group({
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required],
      reason: ['', Validators.required]
    });

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const currentDay = new Date();
    this.currentDate = new Date().getDate();
    this.currentDateDay = this.currentDate + ' ' + days[new Date().getDay()];
    this.getWeekDays(currentDay);
    this.currentWeak = this.datePipe.transform(currentDay, 'ww');
    if (this.currentWeak > 52) {
      this.currentWeak = 1;
    }
    this.getPreviousWeekDate = this.currentWeak;
  }

  getWeekDays(currentDate) {
    this.dateDisplay = [];
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    const curr = new Date(currentDate);
    const first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    this.firstDay = new Date(curr.setDate(first)).toUTCString();
    const startDate = new Date(this.firstDay);
    this.lastDay = new Date(startDate.setDate(startDate.getDate() + 6));
    this.firstDayDate =
      new Date(this.firstDay).getDate() +
      ' ' +
      monthNames[new Date(this.firstDay).getMonth()];
    this.lastDayDate =
      new Date(this.lastDay).getDate() +
      ' ' +
      monthNames[new Date(this.lastDay).getMonth()];
    this.yearFirst = new Date(this.firstDay).getFullYear();
    this.yearLast = new Date(this.lastDay).getFullYear();
    this.currentYear = this.yearLast;
    this.weekNumer = this.datePipe.transform(startDate, 'ww');
    this.taskListFlag =
      new Date(
        this.datePipe.transform(this.firstDay, 'yyyy-MM-dd')
      ).getTime() >= new Date('2018-04-01').getTime()
        ? true
        : false;
    /*Get all the 7 days date in the current week with respective flags */
    for (let i = 0; i < 7; i++) {
      this.getDateDay(i);
    }
  }

  /**function to get date week days timesheet*/
  getDateDay(number) {
    const getDate = new DateDisplay();
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    getDate.day = days[number];
    const date = new Date(this.firstDay);
    date.setDate(new Date(this.firstDay).getDate() + number);
    if (date.getTime() > new Date().getTime()) {
      getDate.flag = false;
    }
    // if (this.timeSheetEntryDate.getTime() >= date.getTime()) {
    //   getDate.disableTimeSheetEntry = true;
    // }
    getDate.date = date.getDate();
    this.dateDisplay.push(getDate);
  }

  submitLeave() {
    this.submitted = true;
    if (this.leaveForm.invalid) {
      return;
    }
    const fromDate = this.leaveForm.value.fromDate;
    const toDate = this.leaveForm.value.toDate;
    if (fromDate && toDate && fromDate.epoc > toDate.epoc) {
      this.fromDateError = 'From Date should be less than To Date';
      return;
    }
    this.leaveForm.controls['fromDate'].setValue(this.datePipe.transform(fromDate.jsdate, 'yyyy-MM-dd'));
    this.leaveForm.controls['toDate'].setValue(this.datePipe.transform(toDate.jsdate, 'yyyy-MM-dd'));
    this.dialogRef.close(this.leaveForm.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/leave-pop-up/leave-pop-up.component.ts